import { first, map, Observable, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { AuthFacade } from '@ideapa/app-auth';

@Injectable({
  providedIn: 'root',
})
export class AnnoGuard implements CanActivate {
  constructor(private authFacade: AuthFacade, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authFacade.anno$.pipe(
      tap((anno) => {
        if (!anno) {
          this.router.navigateByUrl('/', { replaceUrl: true });
        }
      }),
      map((anno) => !!anno),
      first()
    );
  }
}
